import { render, staticRenderFns } from "./oksys.vue?vue&type=template&id=0da954b8&"
import script from "./oksys.vue?vue&type=script&lang=js&"
export * from "./oksys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports